import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, pageContext, replaceBaseUrl } from 'ctm-util-functions';
import { Header as ManorHeader } from '@comparethemarketau/manor-header';
import BrandedLogo from './branded_logo';
import { DynamicComponent } from '../dynamic_component/dynamic_component';
import { ElevenMonthHeader } from './eleven_month_header';

const _Header = (props) => {
    const { enableCustomerAccounts } = props;
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    let customerAccountsUrl;
    const logo = <BrandedLogo />;
    const header = <ManorHeader {...props} logo={logo} authuiURL={customerAccountsUrl} />;
    const pageState = pageContext.getProps().pageState || {};

    if (['confirmation', 'quotes_expired', 'verify'].includes(pageState?.pageName)) {
        return (
            <ElevenMonthHeader
                src={replaceBaseUrl(props.elementProps.image.src, baseAssetsPath)}
                bgColor={props.visualProps.bgColor}
                alt={'Compare the Market Logo'}
                margin={props.visualProps.margin}
            />
        );
    }
    if (enableCustomerAccounts) {
        customerAccountsUrl = get(pageState, 'serverConfig.customerAccountsBaseUrl', null);
    }
    return <DynamicComponent component={header} />;
};

const mapStateToProps = (state, props) => {
    const experimentId = state.getIn(['page', 'experimentId']);

    return {
        ...props,
        enableCustomerAccounts: experimentId === 'customerAccounts'
    };
};

_Header.propTypes = {
    enableCustomerAccounts: PropTypes.bool
};

const Header = connect(mapStateToProps)(_Header);

export { Header };
